import { render } from "./HistogramSlider.vue?vue&type=template&id=af112b8a&ts=true"
import script from "./HistogramSlider.vue?vue&type=script&lang=ts"
export * from "./HistogramSlider.vue?vue&type=script&lang=ts"

import "./HistogramSlider.vue?vue&type=style&index=0&id=af112b8a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__